import { render, staticRenderFns } from "./Comites.vue?vue&type=template&id=b39b7d68&scoped=true&"
import script from "./Comites.vue?vue&type=script&lang=js&"
export * from "./Comites.vue?vue&type=script&lang=js&"
import style0 from "./Comites.vue?vue&type=style&index=0&id=b39b7d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39b7d68",
  null
  
)

export default component.exports